import * as z from "zod";
import { array, boolean, literal, object, string } from "zod";
import { ConfirmCreateBundleSchema } from "../../agents/support-agents/confirm-create-bundle";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
  WithoutId,
} from "../message-parser-utils";

export const CreateBundleCustomerInputContentSchema = object({
  confirmed: boolean().optional(),
  recommendedProducts: array(string()),
});
export type CreateBundleCustomerInputContent = z.infer<
  typeof CreateBundleCustomerInputContentSchema
>;

export const CreateBundleMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.CREATE_BUNDLE),
  structuredContent: ConfirmCreateBundleSchema,
  customerInputContent: CreateBundleCustomerInputContentSchema.optional(),
});

export const CreateBundleMessageDbParser = CreateBundleMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
export type CreateBundleMessageType = z.infer<
  typeof CreateBundleMessageDbParser
>;
export type CreateBundleMessageTypeWithoutId =
  WithoutId<CreateBundleMessageType>;
